import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { frameId: String }

  cancel(event) {
    event.preventDefault()
    const id = this.frameIdValue || this.element.dataset.supportTicketFrameIdValue
    if (!id) {
      this.element.innerHTML = ""
      return
    }

    const frame = document.getElementById(id)
    if (frame) {
      frame.innerHTML = ""
    }
  }
}
